import { onOsDownloadQuote, recalculateCart } from '../shared/shared';
import { LocalQuote } from './local-quote';

export default function async (app) {
    if (window.os_started) return;

    console.log('### Omni seller started');

    const menuEl = app.menu.getMenu();
    if (!menuEl) return;

    menuEl.classList.add('scf-adv-menu-popup--pulsate');

    const tracker = BCSuite.getCartTracker();

    /**
     * type, timestamp, entry
     */
    tracker.onCartUpdate(async (args) => {
        const { cart } = args;
        app.session.sessionDetails.currentCartId = cart.id;
        app.session.sessionDetails.version = cart.version;

        LocalQuote.remove(cart.id);
        recalculateCart(app, app.session.sessionDetails.currentCartId, app.session.sessionDetails.currentCartVersion);
    });

    const { currentCartId, currentCartVersion } = app.session.sessionDetails ?? {};
    let { quotedCartId, quotedCartVersion } = app.session.sessionDetails ?? {};

    if (quotedCartId == currentCartId && quotedCartVersion < currentCartVersion) { 
        recalculateCart(app, quotedCartId, currentCartVersion);
    }

    menuEl.classList.remove('scf-adv-menu-popup--pulsate');
    menuEl.classList.add('scf-adv-menu-popup--pulsate-active');
    setTimeout(() => {
        menuEl.classList.remove('scf-adv-menu-popup--pulsate-active');
    }, 500);

    onOsDownloadQuote((hash, buildUrl) => {
        const url = buildUrl(app.service.getBaseUrl());
        
        window.location.href = url;
    });

    app.session.hooks.on('tcc-changed', (data) => {
        // MenuUI.setSellerStatus({tcc: data});
    });

    window.os_started = true;
};